import { Note, TeamSummary } from "common";
import { useMemo } from "react";

export const useNoteTeam = (note: Note): TeamSummary | null => {
  return useMemo(() => note.teams[0] ?? null, [note.teams]);
};
